<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('Package.List')" :contenttext="$t('Package.TableHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <b-col sm="12">
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" eheader="Package Master" econtent="Package Master"
                eimg="/src/assets/Img/icons/unitmaster.svg" @createNew="IsAdd" />
              <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                dataKey="ID" :exceldownload="true">
                <template v-slot:Status="{ data }">
                  <!-- <Badge v-if="data.IsActive == '0'" severity="warning">{{
                    "InActive"
                  }}</Badge>
                  <Badge v-if="data.IsActive == '1'" severity="success">{{
                    "Active"
                  }}</Badge> -->
                  <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                  <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Package Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:action="{ data }">
                  <span>
                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
                <template v-slot:Add>
                  <span class="add">
                    <AddButton @click="IsAdd()" :btnname="$t('btn.plusaddnew')" class="float-rights my-3">
                    </AddButton>
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" eheader="Package Master" econtent="Package Master"
                eimg="/src/assets/Img/icons/unitmaster.svg" @createNew="IsAdd" />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <p class="light-name">{{ item.Code }}</p>
                        <p class="name">{{ item.Name }}</p>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <!-- <Badge v-if="item.IsActive == '1'" severity="success">{{ "Active" }}</Badge>
                          <Badge v-if="item.IsActive == '0'" severity="warning">{{ "InActive" }}</Badge> -->
                          <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                          <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                        </div>
                        <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                      </div>
                    </div>
                    <p class="light-name">{{ "₹" + item.BaseAmount }}</p>
                    <div class="d-flex align-items-center justify-content-between">
                      <p class="light-name">{{ item.ValidityFromDate }}</p>
                      <p class="light-name">{{ item.ValidityToDate }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  </div>
  <Toast />

  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(dataEdit)"
    @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <ActivatedSuccessfully :visible="popup.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="popup.inactivepop" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, h, computed, onMounted, onUnmounted } from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import Empty from "../../../../../components/Masters/MasterEmpty.vue";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import ActivatedSuccessfully from "../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../components/FormComponents/InActivateSuccessfully.vue";
import Mapping from "../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useToast } from "primevue/usetoast";
import MastersService from "../../../Service/MastersService";
import { checkPermission } from "../../../Service/AccessControl";
import PackageMAsterservice from "../../../Service/PackageMasterService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import moment from "moment";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../components/FormComponents/Export.vue";


export default defineComponent({
  components: {
    Empty,
    Tableview,
    BacktoPage,
    Headerlayout,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    debugger;

    const toast = useToast();
    const router = useRouter();
    const filter = "";
    const showmodalref = ref(false);
    let loading1 = ref(false);
    let loading = ref(false);
    let title = "Item Master";
    const showDialog = ref(false);
    let List: any = ref([]);
    const selectedItem = ref();
    const data = ref([]);
    const rowFocus = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const ObjData = ref();
    let content = ref("");

    const popup = ref({
      activatepop: false,
      inactivepop: false,
    });
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const dataEdit = ref();
    const route = useRoute();
    let storeId = route.query.storeId;

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const headers = [
      {
        header: t('Package.sno'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('Package.code'),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: t('Package.Name'),
        field: "PackageName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },

      {
        header: t('Package.FromDate'),
        field: "ValidityFromDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Package.ToDate'),
        field: "ValidityToDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Package.Price'),
        field: "BaseAmount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor right_td",
        slot: "ProductCount",
      },
      // {
      //   header: 'Surgical / Investigations',
      //   field: 'Surgical',
      //   filterTemplate: 'MultiSelect',
      //   ShowMactchMode: false,
      // },
      {
        header: t('Package.Status'),
        field: "ActiveStatus",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
        fieldDisplay: "false",
        sortable: false,
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      PackageName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ValidityFromDate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ValidityToDate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      BaseAmount: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemCategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemSubGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGenericName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await PackageMAsterservice.getdata();

        let count = 0;
        if (usersData.Admin == 1) {
          response["result"] = response["result"]
            .filter((items) => items.HospitalId == usersData.OrganizationId)
            .map((item) => {
              count = count + 1;
              item.RowNumber = count;
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              item.ValidityFromDate =
                item.Isvalid == 1
                  ? ""
                  : moment(item.ValidityFromDate).format("DD-MM-YYYY");
              item.ValidityToDate =
                item.Isvalid == 1
                  ? ""
                  : moment(item.ValidityToDate).format("DD-MM-YYYY");

              return item;
            });
        } else {
          response["result"] = response["result"]
            .filter(
              (items) =>
                items.HospitalId == usersData.OrganizationId &&
                items.BranchId == usersData.BranchId
            )
            .map((item) => {
              count = count + 1;
              item.RowNumber = count;
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              item.ValidityFromDate =
                item.Isvalid == 1
                  ? ""
                  : moment(item.ValidityFromDate).format("DD-MM-YYYY");
              item.ValidityToDate =
                item.Isvalid == 1
                  ? ""
                  : moment(item.ValidityToDate).format("DD-MM-YYYY");

              return item;
            });
        }


        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }


    const menu = ref();
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    let Editvisible = ref(false);

    const toggle = (event, data) => {
      debugger;
      ObjData.value = data;
      if (data.IsActive == 1) {
        Activevisible.value = false;
        InActivevisible.value = true;
        Editvisible.value = true;
      } else if (data.IsActive == 0) {
        Activevisible.value = true;
        InActivevisible.value = false;
        Editvisible.value = false;
      }
      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(ObjData);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(ObjData, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(ObjData, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(ObjData, 2);
            },
          },
        ],
      },
    ]);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    onMounted(() => {
      debugger;
      window.addEventListener("resize", handleResize);

      document.addEventListener("keydown", onKeyUp);
      IsShow();
      FunctionRights();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true
      ) {
        Editmodel.value = true;
      } else if (event.altKey && event.key == "n") {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (event.key == "d" && rowFocus.value == true) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    function RowClick(event: any) {
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    //Add New PopUp
    const IsAdd = () => {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          path: "/PackageMasterCreation",
          query: { OperationId: ObjOperationId.value.CreateId },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };
    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    function IsConfirmDel(data, status) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = false;
        Deletemodel.value = true;
        data.ActiveStatus = status;
        if (status == 1) {
          content.value = "Activate?";
        } else if (status == 2) {
          content.value = "InActivate?";
        } else {
          content.value = "Delete?";
        }
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      popup.value.activatepop = false;
      popup.value.inactivepop = false;
    }

    //Table List
    async function IsShow() {
      debugger;
      loading.value = true;
      try {
        const response = await PackageMAsterservice.getdata();

        let count = 0;
        if (usersData.Admin == 1) {
          response["result"] = response["result"]
            .filter((items) => items.HospitalId == usersData.OrganizationId)
            .map((item) => {
              count = count + 1;
              item.RowNumber = count;
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              item.ValidityFromDate =
                item.Isvalid == 1
                  ? ""
                  : moment(item.ValidityFromDate).format("DD-MM-YYYY");
              item.ValidityToDate =
                item.Isvalid == 1
                  ? ""
                  : moment(item.ValidityToDate).format("DD-MM-YYYY");

              return item;
            });
        } else {
          response["result"] = response["result"]
            .filter(
              (items) =>
                items.HospitalId == usersData.OrganizationId &&
                items.BranchId == usersData.BranchId
            )
            .map((item) => {
              count = count + 1;
              item.RowNumber = count;
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              item.ValidityFromDate =
                item.Isvalid == 1
                  ? ""
                  : moment(item.ValidityFromDate).format("DD-MM-YYYY");
              item.ValidityToDate =
                item.Isvalid == 1
                  ? ""
                  : moment(item.ValidityToDate).format("DD-MM-YYYY");

              return item;
            });
        }

        List.value = response["result"];

        console.log(List.value);
        loading.value = false;
      } catch (error) {
        alert(error);
      }
    }
    const rowsCount = ref(0);

    // async function itembasedonstore() {
    //   try {
    //     loading.value = true;
    //     const result = await service.ListItemByStoreId(route.query.storeId);
    //     debugger;
    //     console.log(result);
    //     List.value = result["result"];
    //     if (result["result"].length > 0) {
    //       rowsCount.value = result["result"].length;
    //     }
    //     console.log(List.value);
    //     loading.value = false;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    //Edit Click function
    async function IsEdit(data) {
      debugger;
      router.push({
        path: "/PackageMasterCreation",
        query: {
          id: data.value.Id,

          OperationId: ObjOperationId.value.UpdateId,
        },
      });
    }

    //Row Delete
    async function IsDelete(data) {
      debugger;
      loading.value = true;
      const DelID = data.value.Id;

      try {
        let data_response: any = "";
        let data_HMSresponse: any = "";

        if (data.ActiveStatus == 0) {
          data_response = await PackageMAsterservice.Delete(DelID);
          data_HMSresponse = await PackageMAsterservice.DeleteHMS(
            DelID,
            usersData.OrganizationId
          );
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          data_response = await PackageMAsterservice.active(DelID, status);
          debugger;
          data_HMSresponse = await PackageMAsterservice.activeHMS(
            DelID,
            status,
            usersData.OrganizationId
          );
        }
        console.log(data_response);
        let message = data_response["ErrorInfo"].ErrorCode;

        if (message == null) {
          if (data.ActiveStatus == 1) {
            loading.value = false;
            popup.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            loading.value = false;
            popup.value.inactivepop = true;
          } else {
            loading.value = false;
            deletepop.value = true;
          }
          deletepop.value = true;
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    return {
      toggle,
      menu,
      itemListed,
      List,
      loading1,
      filteredColumns,
      globalFilterFields,
      headers,
      filters,
      IsAdd,
      IsShow,
      IsEdit,
      RowClick,
      dataEdit,
      Editmodel,
      onKeyUp,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      loading,
      popup,
      content,
      IsDelete,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobilestorename {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobliestorecode {
  font-size: 16px;
  font-weight: 500;
  margin-top: -7px;
}

.mobilestorelightname {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 400;
}
</style>
